import { GearItemCard } from '../../../Cards/GearItemCard/GearItemCard';
import { CatchGearItem } from '../../types/CatchGearItem';

interface CatchGearCardsProps {
  postGear: CatchGearItem[];
}

export const PostGearCards = ({ postGear }: CatchGearCardsProps) => {
  return (
    <div>
      {postGear.map(({ product: { _id, brand, image, displayName } }) => (
        <GearItemCard
          key={`catch-gear-${_id}`}
          brand={brand.name}
          image={image}
          name={displayName || ''}
        />
      ))}
    </div>
  );
};
